import { render, staticRenderFns } from "./SyllabusInstanceDisplay.vue?vue&type=template&id=52ef8986"
import script from "./SyllabusInstanceDisplay.vue?vue&type=script&lang=js"
export * from "./SyllabusInstanceDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports